import React from 'react';

import './usageDashboard.css';
import DataManager from './DataManager';
import Popover from 'react-simple-popover';
import { connect } from 'react-redux';
import CompanyCard from './Components/CompanyCard';

// eslint-disable-next-line react/no-deprecated
class UsageDashboard extends React.Component {
  constructor(props, context) {
    super(props, context);
    DataManager.setCompanyId(this.props.match.params.companyId);
    this.state = {
      visitorsPopoverOpen: false,
      inquiriesPopoverOpen: false,
      visitorsByCity: [],
      visitorsByCountry: [],
      inquiriesByCity: [],
      inquiriesByCountry: [],
      showByCity: true,
      showByCountry: false,
      companyId: this.props.match.params.companyId,
      companySignature: [],
      showInquiryByCity: true,
      showInquiryByCountry: false
    };
  }

  componentDidMount() {
    let c = DataManager.getCompanyId();
    if (c) {
      DataManager.getCompanyForId(c).then(data => {
        this.setState({
          data: data,
          companyId: c
        });
      });

      DataManager.getCompanySignatureMeta(c).then(data => {
        this.setState({
          companySignature: data
        });
      });

      DataManager.getCompanyMeta(c).then(data => {
        this.setState({
          meta: data
        });
      });
    } else {
    }
  }

  componentWillMount() {
    this.repeatVisitorData();
  }

  renderCatalogues = () => {
    const { meta } = this.state;
    return meta ? <CompanyCard lead={meta} /> : <div />;
  };

  renderInquiriesByCity = () => {
    return [...this.state.inquiriesByCity]
      .sort((city1, city2) => {
        return city1.inquiry_count > city2.inquiry_count ? -1 : 1;
      })
      .map((city, i) => {
        return (
          <div className="VisitorCityRow" key={i}>
            {city.city}{' '}
            <span className="VisitorCityRowCount"> {city.inquiry_count} </span>
          </div>
        );
      });
  };

  renderVisitorsByCity = () => {
    return [...this.state.visitorsByCity]
      .sort((visitor1, visitor2) => {
        return visitor1.visitor_count > visitor2.visitor_count ? -1 : 1;
      })
      .map((visitor, i) => {
        return (
          <div className="VisitorCityRow" key={i}>
            {visitor.city}{' '}
            <span className="VisitorCityRowCount">
              {' '}
              {visitor.visitor_count}{' '}
            </span>
          </div>
        );
      });
  };

  showVisitorsInfo = () => {
    this.setState({
      visitorsPopoverOpen: true
    });
  };

  showInquiriesInfo = () => {
    this.setState({
      inquiriesPopoverOpen: true
    });
  };

  closeVisitorPopover = () => {
    this.setState({
      visitorsPopoverOpen: false
    });
  };

  closeInquiryPopover = () => {
    this.setState({
      inquiriesPopoverOpen: false
    });
  };

  showVisitorCount = () => {
    this.fetchVisitorCountByCity();
  };

  showInquiryCount = () => {
    this.fetchInquiryCountByCity();
  };

  fetchInquiryCountByCity = () => {
    DataManager.getInquiryCountByCity().then(data => {
      this.setState({
        inquiriesByCity: data['cities'],
        inquiriesByCountry: data['countries']
      });
    });
  };

  fetchVisitorCountByCity = () => {
    DataManager.getVisitorCountByCity().then(data => {
      this.setState({
        visitorsByCity: data['cities'],
        visitorsByCountry: data['countries']
      });
    });
  };

  renderVisitorByCountry = () => {
    return [...this.state.visitorsByCountry]
      .sort((visitor1, visitor2) => {
        return visitor1.visitor_count > visitor2.visitor_count ? -1 : 1;
      })
      .map((visitor, i) => {
        return (
          <div className="VisitorCityRow" key={i}>
            {visitor.country}{' '}
            <span className="VisitorCityRowCount">
              {' '}
              {visitor.visitor_count}{' '}
            </span>
          </div>
        );
      });
  };

  renderInquiriesByCountry = () => {
    return [...this.state.inquiriesByCountry]
      .sort((obj1, obj2) => {
        return obj1.inquiry_count > obj2.inquiry_count ? -1 : 1;
      })
      .map((obj, i) => {
        return (
          <div className="VisitorCityRow" key={i}>
            {obj.country}{' '}
            <span className="VisitorCityRowCount"> {obj.inquiry_count} </span>
          </div>
        );
      });
  };

  showByCity = () => {
    this.setState({
      showByCity: true,
      showByCountry: false
    });
  };

  showByCountry = () => {
    this.setState({
      showByCountry: true,
      showByCity: false
    });
  };

  inquiryShowByCity = () => {
    this.setState({
      showInquiryByCity: true,
      showInquiryByCountry: false
    });
  };

  inquiryShowByCountry = () => {
    this.setState({
      showInquiryByCountry: true,
      showInquiryByCity: false
    });
  };

  repeatVisitorData = () => {
    let companyId = DataManager.getCompanyId();
    let repeatCount = DataManager.getRepeatCount();
    DataManager.getVisitorRepeatCount(companyId, repeatCount).then(data => {
      this.setState({
        visitorAboveBaseLevel: data['totalVisitorAboveBaseCount'],
        repeatVisitorPer: data['percentage']
      });
    });
  };

  renderCompanySignature = () => {
    return [...this.state.companySignature].map(day => {
      if (day.status) {
        return <div className="DidOpenApp AppVisitStatus" />;
      } else {
        return <div className="DidNotOpenApp AppVisitStatus" />;
      }
    });
  };

  renderCompanyVisitorSignature = () => {
    let ar = [...this.state.companySignature];

    let total_visitor_opens = 0;
    let total_max = 0;
    let max_visitor_opens = 0;

    return ar
      .map((day, i) => {
        day['total_visitor_opens'] = total_visitor_opens + day['visitor_opens'];
        total_visitor_opens = day['total_visitor_opens'];
        if (day['total_visitor_opens'] > total_max) {
          total_max = day['total_visitor_opens'];
        }

        if (day['visitor_opens'] > max_visitor_opens) {
          max_visitor_opens = day['visitor_opens'];
        }

        return day;
      })
      .map((day, i) => {
        return (
          <div style={{ display: 'inline-block' }}>
            <div
              className="TotalVisitorOpens"
              style={{
                top: 60 - (day['total_visitor_opens'] * 60) / total_max,
                left: i * 3
              }}
            />
            <div
              className="VisitorOpens"
              style={{
                height: (day['visitor_opens'] * 60) / max_visitor_opens
              }}
            />
          </div>
        );
      });
  };

  renderCompanyInquirySignature = () => {
    let ar = [...this.state.companySignature];

    let max_inquiries = 0;

    return ar
      .map((day, i) => {
        if (day['inquiries'] > max_inquiries) {
          max_inquiries = day['inquiries'];
        }

        return day;
      })
      .map((day, i) => {
        return (
          <div style={{ display: 'inline-block' }}>
            <div
              className="Inquiries"
              style={{ height: (day['inquiries'] * 60) / max_inquiries }}
            />
          </div>
        );
      });
  };

  calculateMaxLevels = () => {
    let ar = [...this.state.companySignature];

    let max_inquiries = 0;
    let max_visitor_opens = 0;

    ar.forEach((day, i) => {
      if (day['inquiries'] > max_inquiries) {
        max_inquiries = day['inquiries'];
      }

      if (day['visitor_opens'] > max_visitor_opens) {
        max_visitor_opens = day['visitor_opens'];
      }
    });

    return { max_inquiries, max_visitor_opens };
  };

  renderLabels = () => {
    let o = this.calculateMaxLevels();

    return (
      <div className="LabelsContainer">
        <div className="MaxVisitors"> {o.max_visitor_opens} visitors</div>
        <div className="MaxInquiries"> {o.max_inquiries} inquiries</div>
      </div>
    );
  };

  renderCompany = () => {
    let { company_name } = this.state.data;
    let { companyId } = this.state;
    let phone = this.state.data.phone.split('+')[1];

    return (
      <div className="Company">
        <div className="CompanyName">{company_name}</div>

        <div className="SignatureContainer">
          <div className="CompanySignature">
            {this.renderCompanySignature()}
          </div>

          <div className="CompanyVisitorSignature">
            {this.renderCompanyVisitorSignature()}
          </div>

          <div className="CompanyInquirySignature">
            {this.renderCompanyInquirySignature()}
          </div>

          <div className="Labels">{this.renderLabels()}</div>
        </div>

        <ul className="CompanyMetaContainer">
          <li className="CompanyMeta">
            last seen {this.state.data.last_seen}{' '}
          </li>
          <li className="CompanyMeta">
            acquired {this.state.data.using_since}{' '}
          </li>
          <li className="CompanyMeta">{this.state.data.city}</li>
          <li className="CompanyMeta">{this.state.data.country}</li>
          {this.state.data.android ? (
            <li className="CompanyMeta">Android</li>
          ) : null}
          {this.state.data.ios ? <li className="CompanyMeta">iPhone</li> : null}
          <li className="CompanyMeta">{DataManager.getCompanyCurrency()}</li>
        </ul>

        <ul className="CompanyMetaContainer">
          <li className="CompanyMeta">
            {this.state.data.catalogues.length} catalogues
          </li>

          <li className="CompanyMeta" onClick={this.showInquiriesInfo}>
            <div ref="inquiryTarget">
              <span className="VisitorsCount" onClick={this.showInquiryCount}>
                {' '}
                {this.state.data.total_inquiries} inquiries
              </span>

              <Popover
                placement="bottom"
                container={this}
                target={this.refs.inquiryTarget}
                show={this.state.inquiriesPopoverOpen}
                onHide={this.closeInquiryPopover}
              >
                <div>
                  <a
                    href="#"
                    className="FilterLabel"
                    onClick={this.inquiryShowByCity}
                  >
                    By City
                  </a>
                  <a
                    href="#"
                    className="FilterLabel"
                    onClick={this.inquiryShowByCountry}
                  >
                    By Country
                  </a>
                  {this.state.showInquiryByCity
                    ? this.renderInquiriesByCity()
                    : null}
                  {this.state.showInquiryByCountry
                    ? this.renderInquiriesByCountry()
                    : null}
                </div>
              </Popover>
            </div>
          </li>

          <li className="CompanyMeta" onClick={this.showVisitorsInfo}>
            <div ref="target">
              <span className="VisitorsCount" onClick={this.showVisitorCount}>
                {' '}
                {this.state.data.total_visitors} visitors
              </span>

              <Popover
                placement="bottom"
                container={this}
                target={this.refs.target}
                show={this.state.visitorsPopoverOpen}
                onHide={this.closeVisitorPopover}
              >
                <div>
                  <a href="#" className="FilterLabel" onClick={this.showByCity}>
                    By City
                  </a>
                  <a
                    href="#"
                    className="FilterLabel"
                    onClick={this.showByCountry}
                  >
                    By Country
                  </a>
                  {this.state.showByCity ? this.renderVisitorsByCity() : null}
                  {this.state.showByCountry
                    ? this.renderVisitorByCountry()
                    : null}
                </div>
              </Popover>
            </div>
          </li>
          <li className="CompanyMeta">
            <span>Visitors above base level </span>
            {this.state.visitorAboveBaseLevel}
          </li>
          <li className="CompanyMeta">
            <span>Percentage </span>
            {this.state.repeatVisitorPer}
          </li>
        </ul>

        <ul className="CompanyContactContainer">
          <li className="ContactWhatsApp">
            <a
              href={'https://api.whatsapp.com/send?phone=' + phone}
              target="_blank"
            >
              WhatsApp
            </a>
          </li>
          <li className="ContactCall">
            <a href="#">Call</a>
            <span style={{ marginLeft: 15 }}>{'+' + phone}</span>
          </li>
          <li className="PipedriveUser">
            <div>
              <input
                type="email"
                className={'PipedriveEmailId'}
                id="pipedrive_emailid"
                name="Email id"
                placeholder="Pipedrive email id"
              />
            </div>
          </li>
        </ul>
      </div>
    );
  };

  onCompanyIdChange = e => {
    let newCompanyId = e.target.value.trim();
    this.setState({
      companyInputValue: newCompanyId,
      data: null,
      companyId: newCompanyId
    });

    if (newCompanyId) {
      DataManager.getCompanyForId(newCompanyId.trim()).then(data => {
        this.setState({
          data: data,
          companyId: data.companyId
        });
      });
    }
  };

  render() {
    const { roles } = this.props;
    const { companyId } = this.state;
    return (
      <div className="App">
        <div
          style={{
            marginTop: 75
          }}
        />

        {roles && roles.indexOf('usage') !== -1 ? (
          this.state.data && companyId ? (
            <div>
              {this.renderCompany()}
              <div className="Company CataloguesContainer">
                {this.renderCatalogues()}
              </div>
            </div>
          ) : null
        ) : (
          <div
            style={{
              textAlign: 'center',
              fontSize: '50px',
              color: 'red',
              marginTop: 133
            }}
          >
            You dont have access to this page
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  roles: state.auth.roles
});

export default connect(mapStateToProps)(UsageDashboard);



// WEBPACK FOOTER //
// ./src/pages/UsageDashboard/index.js